export enum CacheTag {
  // Special tags
  CLEAR_ALL = "clear-all",

  // Search related tags
  SEARCH_RECOMMENDED_CITY = "search-recommended-city",
  SEARCH_REGION = "search-region",
  SEARCH_PROPERTY_TYPE = "search-property-type",
  SEARCH_CHECKBOXES = "search-checkboxes",
  SEARCH_PROPERTY_OPTIONS = "search-property-options",

  // Property collections
  PROPERTY_COLLECTION = "collection",
  PROPERTY_COLLECTION_BUY = "collection-buy",
  PROPERTY_COLLECTION_RENT = "collection-rent",
  PROPERTY_COLLECTION_DEVELOPER = "collection-developer",

  // SEO related tags (prefixes for dynamic tags)
  SEO_TEMPLATE = "seo-template",
  SEO_TEMPLATES_BATCH = "seo-templates-batch",
  SEO_METADATA = "metadata",
  SEO_VARIABLES = "seo-variables",
}

export const getPropertyTag = (slug: string): string => `property-${slug}`;

// Utility to get all cache tags for bulk operations
export const getAllCacheTags = (): string[] => {
  return Object.values(CacheTag).filter((tag) => tag !== CacheTag.CLEAR_ALL);
};
